import React from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Bar } from 'react-chartjs-2'
import Monetario from '../Monetario'
import colorChats from '../../lib/colorChats'

// const options = {
//   legend: {
//     display: false,
//     position: 'top'
//   },
//   tooltips: {
//     enabled: true,
//     callbacks: {
//       label: function(tooltipItem, data) {
//         var label = parseFloat(data.datasets[0].data[tooltipItem.index]).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || 'R$ 00,00'
//         var dataset = data.datasets[tooltipItem.datasetIndex]
//         var total = dataset.data.reduce((total, currentElement) => parseFloat(total) + parseFloat(currentElement))
//         var valor = dataset.data[tooltipItem.index]
//         var porcentagem = parseFloat((valor/total*100).toFixed(1))
//         label += ' ('+porcentagem+'%)'
//         return label
//       },
//       title: function(tooltipItem, data) {
//         return data.labels[tooltipItem[0].index]
//       },
//     }
//   },
//   scales: {
//     yAxes: [
//       {
//         ticks: {
//           display: false,
//           min: 0
//         },        
//         gridLines: {
//           drawBorder: false,
//           zeroLineColor: "transparent",
//           color: "rgba(255,255,255,0.1)"
//           //color: "rgba(128,128,128,0.2)"
//         }
//       }
//     ],
//     xAxes: [
//       {
//         barPercentage: 0.8,
//         gridLines: {
//           drawBorder: true,
//           color: "rgba(255,255,255,0.1)",
//           zeroLineColor: "transparent"
//         },
//         ticks: {
//           display: true
//         }
//       }
//     ]
//   }
// }

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Chart.js Bar Chart',
    },
  
  }, tooltips: {
    enabled: true,
    callbacks: {
      label: function (tooltipItem, data) {
        let total = 0;
        let valor = parseFloat(tooltipItem.value).toFixed(2);
        let label = parseFloat(tooltipItem.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) || 'R$ 00,00';
        data.datasets.forEach(valor=>{
          for(let x = 0; x < valor.data.length; x++){
            total += (parseFloat(valor.data[x]))
          }
        })

        let porcentagem = parseFloat((valor / total * 100).toFixed(1))
        label += ' (' + porcentagem + '%)'
        return label
      },
      title: function (tooltipItem, data) {
        return data.labels[tooltipItem[0].index]
      },
    }
  },
};

const BarrasMes = ({ title, color, dados }) => {
  var data = '';

  if (dados.lojas) {
    let dtset = [];
    //let listaLojas    = [];
    let listaValores = [];

    if (dados.lojas[0] !== 'nenhuma') {
      dados.lojas.forEach((loja, idx) => {

        loja.valores.forEach(valor => {
          listaValores.push(valor);
        })

        dtset.push({
          label: loja.loja,
          data: listaValores,
          // backgroundColor: 'rgba(255, 99, 132, 0.5)',       
          backgroundColor: colorChats.vivida[idx]
        })

        listaValores = [];
      })
    }



    // const labels = ['jul','ago','set','out', 'nov', 'dez'];
    const labels = dados.meses;
    data = {
      labels,
      datasets: dtset
    };

  } else {
    return (<></>)
  }




  return (
    <Card className='mb-0 mt-4'>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor"><Monetario valor={dados.total} /></div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Bar
          data={data}
          options={options}
          width={550}
          height={150}
        />
      </CardBody>
    </Card>
  )
}

export default BarrasMes








